const React = require("react");
const T = React.PropTypes;

const Response = require("../types/Response.js");

const HttpResponse = React.createClass({
    propTypes: {
        style: T.object,
        Response: Response.Type.isRequired
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const style = Object.assign({}, {
            padding: 20,
            lineHeight: "2em",
            fontSize: 20,
            border: "1px solid #ddd",
            fontFamily: "monospace",
            backgroundColor: "#ffe",
            color: "#666"
        }, this.props.style);

        return (<div style={style}>
            {this.props.Response.status} - {this.props.Response.statusText}
            <br />
            URL: {this.props.Response.url}
        </div>);
    }
});

module.exports = HttpResponse;


// WEBPACK FOOTER //
// ./src/components/HttpResponse.jsx